import React, { useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTask from 'components/onboarding/useTask';

import Slide from '@material-ui/core/Slide';
import TaskSummary from 'components/onboarding/TaskSummary';
import TaskDetailHeading from 'components/onboarding/TaskDetailHeading';

function TaskDetail() {
  const classes = useStyles();
  const taskToShow = useTask();
  const [slideIn, setSlideIn] = React.useState(false);

  useEffect(() => {
    setSlideIn(true);
  }, []);

  if (!taskToShow) {
    return null;
  }

  const { fullDescription } = taskToShow;

  return (
    <>
      <div className={classes.stickyHeader}>
        <TaskDetailHeading />
        <TaskSummary task={taskToShow} />
      </div>
      <Slide direction="left" in={slideIn} mountOnEnter unmountOnExit timeout={{ enter: 500 }}>
        <div
          className={classes.fullDescription}
          dangerouslySetInnerHTML={{ __html: fullDescription }}
        />
      </Slide>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  stickyHeader: {
    position: 'sticky',
    top: 49.5,
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.appBar,
  },
  fullDescription: {
    ...theme.typography.body2,
    maxWidth: 330,
    paddingLeft: theme.spacing(4.75),
    '& h5': {
      ...theme.typography.h5,
      marginTop: theme.spacing(),
      marginBottom: theme.spacing(0.5),
    },
    '& h6': {
      ...theme.typography.h6,
      // @ts-ignore
      color: theme.colors.gray2,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(),
      '& a': {
        textDecoration: 'underline',
        color: 'inherit',
      },
    },
    '& p': {
      marginBottom: theme.spacing(2.5),
    },
    '& b': {
      // @ts-ignore
      fontWeight: theme.typography.fontWeight.semiBold,
    },
    '& a': {
      textDecoration: 'underline',
      color: theme.palette.secondary.main,
    },
    '& ol': {
      paddingInlineStart: `${theme.spacing(2.5)}px`,
      marginBottom: theme.spacing(2.5),
    },
    '& ol > li': {
      listStyleType: 'decimal !important',
    },
    '& ul': {
      paddingInlineStart: `${theme.spacing(2.5)}px`,
      marginBottom: theme.spacing(2.5),
    },
    '& ul > li': {
      listStyleType: 'disc !important',
    },
  },
}));

export default TaskDetail;
